<template>
  <div class="fillSpace">
    <AppMenu>
      <template v-slot:topleft>
        <div class="container-title">
          <RoundButton
            class="bordered back"
            href="/"
            :width="currentScreenWidth > 1024 ? 35 : 25"
            image="ic-arrow-back.svg"
          />
          <h2 class="page-title">
            <span class="page-title-text">{{ getWebcontrol('Settings-Titre-Selectioner') }}</span>
          </h2>
        </div>
      </template>
      <template v-slot:bottomrightincontainer>
        <img class="logo-bottom-right" src="../assets/logo.png" />
      </template>
    </AppMenu>

    <div class="background">
      <div class="navigationPaneContainer">
        <div class="list-pannel">
          <Pane :height="160" class="limit-width">
            <SettingsPane
              @loaded="save"
              ref="correct"
              title="Corriger votre vision"
              subtitle="choisir une correction"
              category="correct"
              image="ic-correction.svg"
            />
          </Pane>
          <Pane :height="160" class="limit-width">
            <SettingsPane
              @loaded="save"
              ref="protect"
              title="Protéger vos yeux"
              subtitle="choisir une protection"
              category="protect"
              image="ic-protection.svg"
            />
          </Pane>
          <Pane :height="160" class="limit-width">
            <SettingsPane
              @loaded="save"
              ref="optimise"
              title="Optimiser vos verres"
              subtitle="choisir un traitement"
              category="optimize"
              image="ic-optimisation.svg"
            />
          </Pane>
        </div>
        <PlainButton
          :color="'white'"
          class="valid-select"
          image="ic-arrow-link.svg"
          :bold="''"
          @go="saveInput"
          :text="'Enregistrer la sélection'.toUpperCase()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppMenu from '@Components/Menu.vue';
import RoundButton from '@Components/Menus/RoundButton.vue';
import Pane from '@Components/Pane.vue';
import SettingsPane from '@Components/Panes/Settings.vue';
import PlainButton from '../components/Menus/PlainButton';
import Api from '../services/Api';

export default {
  data() {
    return {
      protectList: [],
      optimizeList: [],
      correctList: [],
      allValueLoaded: false,
    };
  },
  components: {
    PlainButton,
    AppMenu,
    RoundButton,
    Pane,
    SettingsPane,
  },
  methods: {
    getWebcontrol(key) {
      return this.$store.getters.getValueById(key);
    },
    save(value) {
      switch (Object.keys(value)[0]) {
        case 'correct':
          this.correctList = value.correct;
          break;
        case 'protect':
          this.protectList = value.protect;
          break;
        case 'optimize':
          this.optimizeList = value.optimize;
          break;
      }
      if (
        !(Object.entries(this.protectList).length === 0 && this.protectList.constructor === Object) &&
        !(Object.entries(this.optimizeList).length === 0 && this.optimizeList.constructor === Object) &&
        !(Object.entries(this.correctList).length === 0 && this.correctList.constructor === Object)
      ) {
        this.allValueLoaded = true;
      }
    },
    saveInput() {
      if (this.allValueLoaded) {
        Api.updateProducts({
          protect: this.getIdArray(this.protectList),
          correct: this.getIdArray(this.correctList),
          optimize: this.getIdArray(this.optimizeList),
        }).then(() => {
          this.$store.dispatch('loadProducts');
          this.$store.dispatch('loadProductsEssilor');
          this.$router.push('/');
        });
      }
    },
    getIdArray(list) {
      var listId = [];
      for (var element in list) {
        if (list[element].isSelected) {
          listId.push(element);
        }
      }
      return listId;
    },
  },
  computed: {
    currentScreenWidth() {
      return window.outerWidth;
    },
  },
  mounted() {
    this.$gtag.pageview({
      page_title: 'Configuration',
      page_path: '/Configuration',
      page_location: window.location.href,
    });
  },
};
</script>

<style scoped>
.limit-width {
  min-width: 288px;
}

.fillSpace {
  width: 100%;
  height: 100%;
}
img.verre {
  position: absolute;
  left: -3%;
  top: -15%;
}

.hStackable {
  padding: 20px 0;
  margin: 0 20px;
  width: 17vw;
  overflow-y: auto;
}

.list-pannel {
  display: flex;
  height: 77%;
}

.navigationPaneContainer {
  display: flex;
  width: 72%;
  height: 100%;
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.background {
  top: 10vh;
  bottom: 10vh;
  left: 7vw;
  right: 7vw;
  overflow: hidden;
  position: absolute;
  background-color: #e6edf5;
}
.container-title {
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
}
.page-title {
  padding-left: 20px;
  align-self: center;
}
.back:hover {
  border: 1px solid black;
}
.valid-select {
  width: 320px;
  padding: 0 2%;
  white-space: nowrap;
  margin-top: 5vh;
  margin-bottom: 0;
  background-color: #5e6a71;
  position: relative;
  color: white;
}
/*
résolution moins de 1024
*/
@media (max-width: 1024px) {
  .limit-width {
    min-width: 200px;
  }
}
</style>
